import React from 'react';

export function ChoiceField({ title, value, options, onChange, note }) {
  return (
    <fieldset className="field">
      <legend className="field-title">{title} <span className="optional">0–2 pontos</span></legend>
      <div className="choice-list">
        {options.map((option, index) => (
          <label key={option} className={`choice ${value === index ? 'selected' : ''}`}>
            <input type="radio" name={title} checked={value === index} onChange={() => onChange(index)} />
            <span>{option}</span><strong>{index} pt</strong>
          </label>
        ))}
      </div>
      {note && <p className="field-note">{note}</p>}
    </fieldset>
  );
}

export function CheckCards({ title, items, selected, onToggle }) {
  return (
    <fieldset className="field">
      <legend className="field-title">{title}</legend>
      <div className="check-grid">
        {items.map((item, index) => (
          <label key={item} className={`check-card ${selected.includes(index) ? 'selected' : ''}`}>
            <input type="checkbox" checked={selected.includes(index)} onChange={() => onToggle(index)} />
            <span>{item}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
